import { Boxes, Fingerprint, Flame, Gauge, LayoutGrid, Users } from 'lucide-react';
import type { TopicDefinition } from '@/shared/surfaces/TopicCatalogTypes';

/**
 * The catalog of insight topics surfaced on the AI Explorer experience. Order here
 * is the default; the L0 gallery re-ranks by a data-driven priority score so the
 * most striking findings rise to the top.
 */
export const AI_EXPLORER_CATALOG: TopicDefinition[] = [
    {
        id: 'work-mix',
        title: 'What is your AI actually doing?',
        hook: 'A handful of task types soak up most of every request.',
        question: 'Which kinds of work flow through AI — and which ones dominate?',
        icon: LayoutGrid,
        accent: 'indigo',
        vizKind: 'ranked-bars',
        primaryField: 'task_category',
        headlineMetric: 'turns',
        unitLabel: 'prompts',
        lensLabel: 'task category',
        lensPlural: 'task categories',
    },
    {
        id: 'team-adoption',
        title: "Who lives in AI — and who's gone dark?",
        hook: 'Adoption is wildly uneven from one team to the next.',
        question: 'Which departments lean into AI, and which are barely touching it?',
        icon: Users,
        accent: 'teal',
        vizKind: 'ranked-bars',
        primaryField: 'user_department',
        headlineMetric: 'turns',
        unitLabel: 'prompts',
        lensLabel: 'department',
        lensPlural: 'departments',
    },
    {
        id: 'difficulty-ladder',
        title: 'Do they trust AI with the hard stuff?',
        hook: 'The work sent to AI clusters at a telling difficulty.',
        question: 'How does task difficulty break down across the kinds of work?',
        icon: Gauge,
        accent: 'amber',
        vizKind: 'matrix',
        primaryField: 'task_category',
        secondaryField: 'difficulty',
        headlineMetric: 'turns',
        unitLabel: 'prompts',
        lensLabel: 'task category',
        lensPlural: 'task categories',
        matrixRowLimit: 8,
    },
    {
        id: 'model-reach',
        title: 'The model wardrobe',
        hook: 'Different models get pulled out for different jobs.',
        question: 'Which models do people reach for, and for which difficulty of work?',
        icon: Boxes,
        accent: 'violet',
        vizKind: 'matrix',
        primaryField: 'model',
        secondaryField: 'difficulty',
        headlineMetric: 'turns',
        unitLabel: 'prompts',
        lensLabel: 'model',
        lensPlural: 'models',
        matrixRowLimit: 8,
    },
    {
        id: 'power-users',
        title: 'The quiet power users',
        hook: 'A small group drives an outsized share of all AI activity.',
        question: 'Who are the heaviest AI users, and what do they lean on it for?',
        icon: Flame,
        accent: 'rose',
        vizKind: 'ranked-bars',
        primaryField: 'user_id',
        headlineMetric: 'turns',
        unitLabel: 'prompts',
        lensLabel: 'person',
        lensPlural: 'people',
    },
    {
        id: 'work-detail',
        title: 'The fingerprints of the work',
        hook: 'Zoom past the categories and the specific jobs come into focus.',
        question: 'What specific tasks are people actually asking AI to do?',
        icon: Fingerprint,
        accent: 'cyan',
        vizKind: 'ranked-bars',
        primaryField: 'task_subcategory',
        headlineMetric: 'turns',
        unitLabel: 'prompts',
        lensLabel: 'specific task',
        lensPlural: 'specific tasks',
    },
];
